import { t } from "@lingui/macro";
import { CreditCard, FileText, Rocket, Search, Send, ShieldCheck } from "lucide-react";

import { Seo } from "@/client/components/seo";

import { CtaBand, FeatureCard, PageHero, Section } from "../_components/page-shell";

export const HelpPage = () => {
  const topics = [
    {
      icon: Rocket,
      title: t`Getting started`,
      description: t`Set up your account and take your first steps with Izicvs.`,
    },
    {
      icon: FileText,
      title: t`Building your resume`,
      description: t`Create, edit, and polish resumes that stand out.`,
    },
    {
      icon: Search,
      title: t`Job search and matching`,
      description: t`Discover roles and find the ones that fit you best.`,
    },
    {
      icon: Send,
      title: t`Applying and tracking`,
      description: t`Apply with confidence and keep tabs on every application.`,
    },
    {
      icon: CreditCard,
      title: t`Account and billing`,
      description: t`Manage your plan, invoices, and payment details.`,
    },
    {
      icon: ShieldCheck,
      title: t`Privacy and data`,
      description: t`Understand how we protect and handle your information.`,
    },
  ];

  return (
    <>
      <Seo
        title={t`Help center`}
        description={t`Browse common topics or reach the Izicvs team when you need a hand.`}
        path="/help"
        breadcrumb={t`Help Center`}
      />

      <PageHero
        eyebrow={t`Help Center`}
        title={t`How can we help?`}
        subtitle={t`Browse common topics or reach out to our team when you need a hand.`}
      />

      <Section>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic, index) => (
            <FeatureCard
              key={topic.title}
              icon={topic.icon}
              title={topic.title}
              description={topic.description}
              index={index}
            />
          ))}
        </div>
      </Section>

      <CtaBand
        title={t`Still need help?`}
        description={t`Our team is happy to answer your questions and help you get the most out of Izicvs.`}
        ctaLabel={t`Contact us`}
        to="/contact"
      />
    </>
  );
};
